import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CommonCard from '../card/CommonCard';
import ProgressBar from '../charts/progressBar';
import { UserEmblem } from '../../assets/images';
import { useLevels } from '../../context/levels';

export const LevelProgressCard = ({ 
    level = 1, 
    exp = 0, 
    onClick,
    sx = {}
}) => {
    const theme = useTheme();
    const { userLevels } = useLevels();

    const currentLevel = level || 1;
    const userExp = exp || 0;
    const currentLevelData = userLevels?.find(l => l.level === currentLevel);
    const prevLevelData = userLevels?.find(l => l.level === currentLevel - 1);
    const requiredExp = currentLevel > 99 ? 50000 : (currentLevelData?.requiredExp || 0);
    const currentExp = currentLevel > 99
        ? 50000
        : Math.max(0, userExp - (prevLevelData?.totalExp || 0));

    return (
        <CommonCard onClick={onClick} sx={{ cursor: onClick ? 'pointer' : 'default', ...sx }}>
            <Typography sx={{
                fontSize: '25px',
                fontWeight: 700,
                letterSpacing: '-0.75px'
            }}>
                LV.{currentLevel}
            </Typography>

            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                alignSelf: 'stretch',
            }}>
                {/* Current Level Icon */}
                <Box sx={{
                    display: 'flex',
                    width: '60px',
                    height: '60px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    aspectRatio: '1/1',
                }}>
                    <UserEmblem
                        level={currentLevel}
                        size={60}
                    />
                </Box>

                {/* Progress Bar */}
                <ProgressBar
                    rangeStart={0}
                    rangeEnd={requiredExp}
                    start={0}
                    end={Math.min(currentExp, requiredExp)}
                    height="20px"
                    showCurrentIndicator={false}
                    showProgress={true}
                    showValueLabel={true}
                    progressColor={'#18CB00'}
                    sx={{ alignSelf: 'center' }}
                />

                {/* Next Level Icon */}
                <Box sx={{
                    display: 'flex',
                    width: '60px',
                    height: '60px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    aspectRatio: '1/1',
                }}>
                    <UserEmblem
                        level={Math.min(currentLevel + 1, 100)}
                        size={60}
                    />
                </Box>
            </Box>
        </CommonCard>
    );
};

export default LevelProgressCard;

